function Empty() {
  return <div className="basket_empty_message">Cart is empty</div>;
}

export default Empty;
